var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAddFile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15 10C14.45 10 14 10.45 14 11V16.22C14 16.77 13.55 17.22 13 17.22H3C2.45 17.22 2 16.77 2 16.22V6C2 5.45 2.45 5 3 5H8C8.55 5 9 4.55 9 4C9 3.45 8.55 3 8 3H2C0.9 3 0 3.9 0 5V17C0 18.1 0.9 19 2 19H14C15.1 19 16 18.1 16 17V11C16 10.45 15.55 10 15 10Z",
    fill: "#5F6CE1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.02 3H16V0.98C16 0.44 15.56 0 15.02 0H14.99C14.44 0 14 0.44 14 0.98V3H11.99C11.45 3 11.01 3.44 11 3.98C11 3.99 11 4 11 4.01C11 4.56 11.44 5 11.99 5H14V7.01C14 7.55 14.44 8 14.99 7.99C15 7.99 15.01 7.99 15.02 7.99C15.56 7.99 16 7.55 16 7.01V5H18.02C18.56 5 19 4.56 19 4.02V3.98C19 3.44 18.56 3 18.02 3Z",
    fill: "#5F6CE1"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11 7H5C4.45 7 4 7.45 4 8C4 8.55 4.45 9 5 9H11C11.55 9 12 8.55 12 8C12 7.45 11.55 7 11 7Z",
    fill: "#5F6CE1"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11 10H5C4.45 10 4 10.45 4 11C4 11.55 4.45 12 5 12H11C11.55 12 12 11.55 12 11C12 10.45 11.55 10 11 10Z",
    fill: "#5F6CE1"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M11 13H5C4.45 13 4 13.45 4 14C4 14.55 4.45 15 5 15H11C11.55 15 12 14.55 12 14C12 13.45 11.55 13 11 13Z",
    fill: "#5F6CE1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddFile);
export default __webpack_public_path__ + "static/media/addFile.c4929d8536a941ec4b2dc3e787667644.svg";
export { ForwardRef as ReactComponent };